import React from "react";
import SimpleModal from "../global/SimpleModal";

const PDFDocument = React.lazy(() => import("../global/PDFDocument"));

type ILegalModalPropsType = "pdf" | "iframe";

type ILegalModalProps = {
    show: boolean;
    title: string;
    url: string;
    mode: ILegalModalPropsType;
    onClose: (accepted: boolean) => void;
};

const LegalModal: React.FC<ILegalModalProps> = ({
    show,
    title,
    url,
    mode,
    onClose,
}) => {
    let content;
    if (mode === "pdf") {
        content = (
            <React.Suspense fallback={null}>
                <PDFDocument file={url} />
            </React.Suspense>
        );
    } else {
        content = <iframe src={url} />;
    }

    return (
        <SimpleModal
            title={title}
            show={show}
            size="half-screen"
            onRequestClose={onClose}
        >
            {content}
        </SimpleModal>
    );
};

export default LegalModal;
